import { Identifiable, Optional } from './types'

export function updateEntityById<T extends Identifiable>(
	entities: Optional<T[]>,
	id: number,
	updater: (entity: T) => Partial<T>,
) {
	const _entities = entities ?? []
	const entityIndex = _entities.findIndex((entity) => id === entity.id)
	if (entityIndex === -1) {
		return _entities
	}

	const entitiesCopy = [..._entities]
	const entityToUpdate = entitiesCopy[entityIndex]
	entitiesCopy[entityIndex] = { ...entityToUpdate, ...updater(entityToUpdate) }

	return entitiesCopy
}
